import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose Tailwind classes, resolving conflicts in favour of the last one.
 *
 * `clsx` handles conditionals; `twMerge` is what makes a caller's `px-6` beat
 * a component's own `px-4` instead of both landing in the class list and the
 * cascade deciding at random.
 *
 * @param inputs - Class values, conditional or plain.
 * @returns The merged class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
